import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import PlusSVG from '../Icons/Plus';
import ColorSF2 from '../../styles/common/ColorSF2';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: ${ColorSF2.green};
  color: ${ColorSF2.white};
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const SvgWrapper = styled.div`
  margin-right: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

/**
 * エンティティ(企業, グループ, ユーザーなど)を作成するためのボタンコンポーネント
 *
 * @param {Object} props
 * @param {Function} props.onCreate ボタンがクリックされたときのコールバック関数
 * @param {string} props.labelId 表示するメッセージのID（react-intlを使用）
 * @returns {ReactElement} CreateEntityButtonコンポーネント
 *
 * @example <CreateEntityButton onCreate={onCreate} labelId={labelId} />
 */
const CreateEntityButton = ({ onCreate, labelId }) => (
  <ButtonWrapper role="presentation" onClick={onCreate}>
    <SvgWrapper>
      <PlusSVG color={ColorSF2.white} size={13} />
    </SvgWrapper>
    <FormattedMessage id={labelId} />
  </ButtonWrapper>
);

CreateEntityButton.propTypes = {
  onCreate: PropTypes.func.isRequired,
  labelId: PropTypes.string.isRequired,
};

export default CreateEntityButton;
